module.exports = __webpack_public_path__ + "media/containers/common/Images/icMap-28f8c22e64a3b7328e8bcc1fe0936da1.png";